window.addEventListener('DOMContentLoaded', function() {
    window.searchLocator = (() => {
        /**************************/
        /***** VARS / CONSTS ******/
        /**************************/
        const $addressInput = document.getElementById("address-input");
        const $serviceInput = document.getElementById("service-input");
        const $searchForm = document.getElementById("search-form");
        const $searchSubmit = document.getElementById("search-submit");
        const $searchTotal = document.getElementById("search-total");
        const $searchCollection = document.getElementById("search-collection");
        const $searchNoservice = document.getElementById("search-noservice");

        /**********************/
        /******* INIT *******/
        /**********************/
        async function init() {
            // autocomplete
            $addressInput.addEventListener("address_change", (e) => {
                refreshServices(e.target.value);
            });

            refreshForm();
            /**********************/
            /******* EVENTS *******/
            /**********************/
            $serviceInput.addEventListener("change", (e) => {
                refreshForm();
            });
            if ($addressInput.value) {
                await sleep(500);
                let service = $serviceInput.value;
                await refreshServices($addressInput.value);
                $serviceInput.value = service;
            }
        }

        /***********************/
        /****** FUNCTIONS ******/
        /***********************/

        async function refreshServices(address) {
            toggleLoading($searchForm.parentNode, true);
            $serviceInput.value = "";
            if(_theAddress == null && address){
                _theAddress = await getAddressDetail(address);
            }
            if (_theAddress) {
                fetch(_locator.ajaxurl, {
                    method: 'POST',
                    body: new URLSearchParams({
                        action: 'get_services',
                        postcode: _theAddress.properties.postcode,
                        inseecode: _theAddress.properties.citycode
                    }),
                })
                    .then(response => response.json())
                    .then(function (services) {
                        if ($searchNoservice)
                            $searchNoservice.classList.toggle('hidden', (services.data.length > 0));
                        if (services.data.length > 0) {
                            for (let $option of $serviceInput.options) {
                                $option.style.display = (services.data.includes($option.value)) ? 'block' : 'none';
                            }
                            refreshForm();
                        } else {
                            $serviceInput.parentElement.classList.add('disabled');
                            if ($searchCollection)
                                $searchCollection.innerHTML = "";
                            if ($searchTotal)
                                $searchTotal.innerHTML = 0;
                        }
                        toggleLoading($searchForm.parentNode, false);
                    });
            } else {
                _theAddress = null;
                refreshForm();
                toggleLoading($searchForm.parentNode, false);
            }
        }

        const refreshForm = () => {
            $serviceInput.parentElement.classList.toggle('disabled', (_theAddress == null));
            if ($searchSubmit)
                $searchSubmit.toggleAttribute("disabled", ($serviceInput.value != "" && _theAddress != null) == false);
        }

        async function getAddressDetail(address) {
            if (address.length >= 3) {
                const response = await fetch('https://api-adresse.data.gouv.fr/search/?q=' + address);
                const data = await response.json();
                if (Object.keys(data.features).length > 0) {
                    return data.features[0];
                }
            }
            return null;
        }

        return {
            init,
            /*initAutocomplete: function (){                
                const autocomplete = new google.maps.places.Autocomplete($addressInput, {
                    componentRestrictions: {country: "fr"},
                    types: ['cities']
                });    
                google.maps.event.addListener(autocomplete, 'place_changed', function () {
                    let search = autocomplete.getPlace().formatted_address ? autocomplete.getPlace().formatted_address : autocomplete.getPlace().name;
                    refreshServices(search);
                });
            }*/
        }
    });
    const searchLocatorInstance = searchLocator();
    searchLocatorInstance.init();
    //searchLocatorInstance.initAutocomplete();
    this.window.searchLocator = searchLocatorInstance; // for tarteaucitron

    async function toggleLoading($element, toggle) {
        if (!toggle) await sleep(500);
        $element.classList.toggle('loading', toggle);
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
});